// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuarantineSummary } from './quarantine-summary';
import {
    QuarantineSummaryFromJSON,
    QuarantineSummaryFromJSONTyped,
    QuarantineSummaryToJSON,
    QuarantineSummaryToJSONTyped,
} from './quarantine-summary';
import type { RunStatistics } from './run-statistics';
import {
    RunStatisticsFromJSON,
    RunStatisticsFromJSONTyped,
    RunStatisticsToJSON,
    RunStatisticsToJSONTyped,
} from './run-statistics';
import type { ReviewStatus } from './review-status';
import {
    ReviewStatusFromJSON,
    ReviewStatusFromJSONTyped,
    ReviewStatusToJSON,
    ReviewStatusToJSONTyped,
} from './review-status';
import type { RunStatus } from './run-status';
import {
    RunStatusFromJSON,
    RunStatusFromJSONTyped,
    RunStatusToJSON,
    RunStatusToJSONTyped,
} from './run-status';
import type { ConformanceError } from './conformance-error';
import {
    ConformanceErrorFromJSON,
    ConformanceErrorFromJSONTyped,
    ConformanceErrorToJSON,
    ConformanceErrorToJSONTyped,
} from './conformance-error';

/**
 * 
 * @export
 * @interface UpdateRunResponseContent
 */
export interface UpdateRunResponseContent {
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    assignedTo?: string;
    /**
     * 
     * @type {Array<ConformanceError>}
     * @memberof UpdateRunResponseContent
     */
    conformanceErrors?: Array<ConformanceError>;
    /**
     * 
     * @type {Date}
     * @memberof UpdateRunResponseContent
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    dataStreamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRunResponseContent
     */
    dryRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    dtaVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    inputLocation?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateRunResponseContent
     */
    lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    parentRunId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    quarantineLocation?: string;
    /**
     * 
     * @type {QuarantineSummary}
     * @memberof UpdateRunResponseContent
     */
    quarantineSummary?: QuarantineSummary;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    resolution?: string;
    /**
     * 
     * @type {ReviewStatus}
     * @memberof UpdateRunResponseContent
     */
    reviewStatus?: ReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    runId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    specId: string;
    /**
     * 
     * @type {RunStatistics}
     * @memberof UpdateRunResponseContent
     */
    statistics?: RunStatistics;
    /**
     * 
     * @type {RunStatus}
     * @memberof UpdateRunResponseContent
     */
    status: RunStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunResponseContent
     */
    studyId: string;
}



/**
 * Check if a given object implements the UpdateRunResponseContent interface.
 */
export function instanceOfUpdateRunResponseContent(value: object): value is UpdateRunResponseContent {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('runId' in value) || value['runId'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function UpdateRunResponseContentFromJSON(json: any): UpdateRunResponseContent {
    return UpdateRunResponseContentFromJSONTyped(json, false);
}

export function UpdateRunResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRunResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'conformanceErrors': json['conformanceErrors'] == null ? undefined : ((json['conformanceErrors'] as Array<any>).map(ConformanceErrorFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'dataStreamId': json['dataStreamId'] == null ? undefined : json['dataStreamId'],
        'dryRun': json['dryRun'],
        'dtaVersion': json['dtaVersion'] == null ? undefined : json['dtaVersion'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'inputLocation': json['inputLocation'] == null ? undefined : json['inputLocation'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'parentRunId': json['parentRunId'] == null ? undefined : json['parentRunId'],
        'quarantineLocation': json['quarantineLocation'] == null ? undefined : json['quarantineLocation'],
        'quarantineSummary': json['quarantineSummary'] == null ? undefined : QuarantineSummaryFromJSON(json['quarantineSummary']),
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : ReviewStatusFromJSON(json['reviewStatus']),
        'runId': json['runId'],
        'specId': json['specId'],
        'statistics': json['statistics'] == null ? undefined : RunStatisticsFromJSON(json['statistics']),
        'status': RunStatusFromJSON(json['status']),
        'studyId': json['studyId'],
    };
}

export function UpdateRunResponseContentToJSON(json: any): UpdateRunResponseContent {
    return UpdateRunResponseContentToJSONTyped(json, false);
}

export function UpdateRunResponseContentToJSONTyped(value?: UpdateRunResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedTo': value['assignedTo'],
        'conformanceErrors': value['conformanceErrors'] == null ? undefined : ((value['conformanceErrors'] as Array<any>).map(ConformanceErrorToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'dataStreamId': value['dataStreamId'],
        'dryRun': value['dryRun'],
        'dtaVersion': value['dtaVersion'],
        'errorMessage': value['errorMessage'],
        'fileName': value['fileName'],
        'inputLocation': value['inputLocation'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'parentRunId': value['parentRunId'],
        'quarantineLocation': value['quarantineLocation'],
        'quarantineSummary': QuarantineSummaryToJSON(value['quarantineSummary']),
        'resolution': value['resolution'],
        'reviewStatus': ReviewStatusToJSON(value['reviewStatus']),
        'runId': value['runId'],
        'specId': value['specId'],
        'statistics': RunStatisticsToJSON(value['statistics']),
        'status': RunStatusToJSON(value['status']),
        'studyId': value['studyId'],
    };
}
